var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        title: _vm.dialogTitle,
        visible: _vm.dialogVisible,
        top: "5vh",
        width: "650px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: { model: _vm.form, rules: _vm.rules, "label-position": "top" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("podInvalidKeyword.invalidType"),
                prop: "keywordType",
              },
            },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    placeholder: _vm.$t("podInvalidKeyword.pleaseSelect"),
                  },
                  model: {
                    value: _vm.form.keywordType,
                    callback: function ($$v) {
                      _vm.$set(_vm.form, "keywordType", $$v)
                    },
                    expression: "form.keywordType",
                  },
                },
                _vm._l(_vm.typeOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("podInvalidKeyword.nameZh"),
                prop: "typeLabel",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("podInvalidKeyword.nameZhPlaceholder"),
                  maxlength: "60",
                },
                model: {
                  value: _vm.form.typeLabel,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "typeLabel", $$v)
                  },
                  expression: "form.typeLabel",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("podInvalidKeyword.namePu"),
                prop: "typeLabelPu",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("podInvalidKeyword.namePuPlaceholder"),
                  maxlength: "100",
                },
                model: {
                  value: _vm.form.typeLabelPu,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "typeLabelPu", $$v)
                  },
                  expression: "form.typeLabelPu",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("podInvalidKeyword.keywords"),
                prop: "keywords",
              },
            },
            [
              _c(
                "div",
                { staticClass: "keyword-box" },
                [
                  _vm._l(_vm.form.keywords, function (keyword, index) {
                    return _c(
                      "el-tag",
                      {
                        key: index,
                        staticClass: "keyword-tag",
                        attrs: { closable: "", size: "small" },
                        on: {
                          close: function ($event) {
                            return _vm.removeKeyword(index)
                          },
                        },
                      },
                      [_vm._v(_vm._s(keyword) + " ")]
                    )
                  }),
                  _c("el-input", {
                    staticClass: "keyword-input",
                    attrs: {
                      placeholder: _vm.$t(
                        "podInvalidKeyword.keywordPlaceholder"
                      ),
                      maxlength: "100",
                    },
                    on: {
                      blur: function ($event) {
                        return _vm.addKeywords(_vm.keywordInput)
                      },
                    },
                    nativeOn: {
                      keydown: function ($event) {
                        return _vm.handleKeywordKeydown($event)
                      },
                    },
                    model: {
                      value: _vm.keywordInput,
                      callback: function ($$v) {
                        _vm.keywordInput = $$v
                      },
                      expression: "keywordInput",
                    },
                  }),
                ],
                2
              ),
              _c("div", { staticClass: "keyword-tip" }, [
                _vm._v(
                  " " + _vm._s(_vm.$t("podInvalidKeyword.keywordTip")) + " "
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "span",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("podInvalidKeyword.cancel")) + " ")]
          ),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.submitForm } },
            [_vm._v(" " + _vm._s(_vm.$t("podInvalidKeyword.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }